"use client";

import { useActionState } from "react";
import { login, type LoginState } from "./actions";

const initialState: LoginState = {};

export default function LoginPage() {
  const [state, formAction, pending] = useActionState(login, initialState);

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-sm flex-col justify-center">
      <div className="mb-6 flex flex-col items-center text-center">
        <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-white shadow-sm">
          <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7">
            <path
              d="M5 16.5V8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8.5"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <rect x="5" y="8" width="14" height="6" rx="1" fill="currentColor" fillOpacity="0.35" />
            <path d="M3 19h18" stroke="var(--brand-sky)" strokeWidth="2" strokeLinecap="round" />
            <circle cx="8.5" cy="16.5" r="1.4" fill="currentColor" />
            <circle cx="15.5" cy="16.5" r="1.4" fill="currentColor" />
          </svg>
        </div>
        <h1 className="text-xl font-bold tracking-tight text-text">תפעול גנרטורים</h1>
        <p className="text-sm text-text-muted">יחידת חשמל · רכבת ישראל</p>
      </div>

      <form action={formAction} className="card space-y-4">
        <div>
          <label htmlFor="email" className="label">
            אימייל
          </label>
          <input id="email" name="email" type="email" required autoComplete="username" className="input" />
        </div>
        <div>
          <label htmlFor="password" className="label">
            סיסמה
          </label>
          <input
            id="password"
            name="password"
            type="password"
            required
            autoComplete="current-password"
            className="input"
          />
        </div>
        {state.error && (
          <p className="rounded-lg bg-red/10 px-3 py-2 text-sm text-red">{state.error}</p>
        )}
        <button type="submit" disabled={pending} className="btn btn-primary w-full">
          {pending ? "מתחבר/ת…" : "התחברות"}
        </button>
      </form>
    </div>
  );
}
